import { EVALUATION_TYPE_ORDER, findAttachedGroupEvaluation } from './evaluationSelection';

import type { EvaluationTypeValue } from '@/constants/cycle-evaluation/CycleEvaluation';
import type { CycleEvaluationStatusValue } from '@/constants/cycle-evaluation/CycleEvaluation';
import type { CycleEvaluationGroup } from '@/types/cycle-evaluation/CycleEvaluationGroup';

import { CycleEvaluationStatus } from '@/constants/cycle-evaluation/CycleEvaluation';
import { CycleEvaluationGroupStatus } from '@/types/cycle-evaluation/CycleEvaluationGroup';

export interface EvaluationElementsTransitions {
    typesToCreate: EvaluationTypeValue[];
    typesToReactivate: EvaluationTypeValue[];
    typesToDeactivate: EvaluationTypeValue[];
}

export const resolveEvaluationElementsTransitions = ({
    group,
    selectedTypes,
}: {
    group: CycleEvaluationGroup | undefined;
    selectedTypes: readonly EvaluationTypeValue[];
}): EvaluationElementsTransitions => {
    const transitions: EvaluationElementsTransitions = {
        typesToCreate: [],
        typesToReactivate: [],
        typesToDeactivate: [],
    };

    EVALUATION_TYPE_ORDER.forEach((type) => {
        const attached = findAttachedGroupEvaluation(group, type);
        const isSelected = selectedTypes.includes(type);
        const isDormant = attached?.status === CycleEvaluationStatus.INACTIVE;

        if (isSelected && !attached) {
            transitions.typesToCreate.push(type);

            return;
        }

        if (isSelected && isDormant) {
            transitions.typesToReactivate.push(type);

            return;
        }

        if (!isSelected && attached && !isDormant) {
            transitions.typesToDeactivate.push(type);
        }
    });

    return transitions;
};

// Waking an evaluation straight to Active on a cycle that has never launched would arm its sends.
export const resolveReactivatedStatus = (
    group: CycleEvaluationGroup | undefined,
): CycleEvaluationStatusValue =>
    group?.status === CycleEvaluationGroupStatus.DRAFT
        ? CycleEvaluationStatus.DRAFT
        : CycleEvaluationStatus.ACTIVE;
